import { type ComponentPropsWithoutRef, memo } from 'react';

import { Command } from '@air/cmdk';
import { SearchIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

export type ComboboxInputProps = ComponentPropsWithoutRef<typeof Command.Input>;

export const ComboboxInput = memo(({ className, placeholder = 'Search', ...restOfProps }: ComboboxInputProps) => {
  return (
    <div
      className={cn(
        'sticky top-0 z-1 flex h-10 shrink-0 items-center gap-2 border-b ads:border-b-default border-b-gray-5 ads:bg-raised bg-surface-1',
        className,
      )}
      data-testid="COMBOBOX_INPUT"
    >
      <SearchIcon className="absolute top-1/2 left-4 -translate-y-1/2 ads:text-icon-default text-gray-10" size="sm" />
      <Command.Input
        className="size-full rounded-t-4 bg-transparent pl-10 ads:text-primary text-14 text-gray-12 outline-none"
        data-testid="COMBOBOX_INPUT_INPUT"
        placeholder={placeholder}
        {...restOfProps}
      />
    </div>
  );
});

ComboboxInput.displayName = 'ComboboxInput';
